/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const toggleFollow = /* GraphQL */ `
  mutation ToggleFollow($followeeID: ID!) {
    toggleFollow(followeeID: $followeeID) {
      id
      username
      identityId
      username_lowercase
      email
      displayName
      displayName_lowercase
      avatar
      coverPhoto
      bio
      website
      location
      role
      followersCount
      followingCount
      postsCount
      watchlistPublic
      interests
      languagePreferences
      verified
      totalAchievementPoints
      titles
      titleOrder
      titleUpdatedAt
      titleSource
      activeBadges
      badgeDisplaySettings
      reviewsCount
      likesReceived
      moviesWatched
      earlyDiscoveries
      loginStreak
      lastLoginDate
      createdAt
      updatedAt
      posts {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      following {
        nextToken
        __typename
      }
      userWatchlists {
        nextToken
        __typename
      }
      userWatchlistItems {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      movieInteractions {
        nextToken
        __typename
      }
      showInteractions {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      conversationsAsUser2 {
        nextToken
        __typename
      }
      groupParticipations {
        nextToken
        __typename
      }
      sentInvitations {
        nextToken
        __typename
      }
      receivedInvitations {
        nextToken
        __typename
      }
      postReports {
        nextToken
        __typename
      }
      movieReports {
        nextToken
        __typename
      }
      showReports {
        nextToken
        __typename
      }
      movieReviews {
        nextToken
        __typename
      }
      showReviews {
        nextToken
        __typename
      }
      reviewReports {
        nextToken
        __typename
      }
      reviewLikes {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      achievementPosts {
        nextToken
        __typename
      }
      progressBoosts {
        nextToken
        __typename
      }
      achievementNotifications {
        nextToken
        __typename
      }
      titleHistory {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      blockedByUsers {
        nextToken
        __typename
      }
      reportsMade {
        nextToken
        __typename
      }
      reportsReceived {
        nextToken
        __typename
      }
      mutedUsers {
        nextToken
        __typename
      }
      mutedByUsers {
        nextToken
        __typename
      }
      newsBookmarks {
        nextToken
        __typename
      }
      newsViews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const addComment = /* GraphQL */ `
  mutation AddComment($input: CreateCommentInput!) {
    addComment(input: $input) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const toggleLike = /* GraphQL */ `
  mutation ToggleLike($postID: ID!) {
    toggleLike(postID: $postID) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const sharePost = /* GraphQL */ `
  mutation SharePost($postID: ID!, $message: String) {
    sharePost(postID: $postID, message: $message) {
      id
      postID
      userID
      message
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const markNotificationRead = /* GraphQL */ `
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateMovieInteraction = /* GraphQL */ `
  mutation UpdateMovieInteraction($input: UpdateMovieInteractionInput!) {
    updateMovieInteraction(input: $input) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateShowInteraction = /* GraphQL */ `
  mutation UpdateShowInteraction($input: UpdateShowInteractionInput!) {
    updateShowInteraction(input: $input) {
      id
      userID
      showID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const adminBoostHypeRating = /* GraphQL */ `
  mutation AdminBoostHypeRating($input: AdminBoostHypeRatingInput!) {
    adminBoostHypeRating(input: $input) {
      contentID
      contentType
      newHypeRating
      boostAmount
      reason
      __typename
    }
  }
`;
export const createConversationCustom = /* GraphQL */ `
  mutation CreateConversationCustom($input: CreateConversationInput!) {
    createConversationCustom(input: $input) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const sendMessageCustom = /* GraphQL */ `
  mutation SendMessageCustom($input: CreateMessageInput!) {
    sendMessageCustom(input: $input) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const markMessageAsRead = /* GraphQL */ `
  mutation MarkMessageAsRead($messageID: ID!) {
    markMessageAsRead(messageID: $messageID) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const markConversationAsRead = /* GraphQL */ `
  mutation MarkConversationAsRead($conversationId: ID!, $userId: ID!) {
    markConversationAsRead(conversationId: $conversationId, userId: $userId) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const leaveGroup = /* GraphQL */ `
  mutation LeaveGroup($conversationId: ID!, $userId: ID!) {
    leaveGroup(conversationId: $conversationId, userId: $userId)
  }
`;
export const archiveConversation = /* GraphQL */ `
  mutation ArchiveConversation(
    $conversationId: ID!
    $userId: ID!
    $unarchive: Boolean
  ) {
    archiveConversation(
      conversationId: $conversationId
      userId: $userId
      unarchive: $unarchive
    ) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteConversationCustom = /* GraphQL */ `
  mutation DeleteConversationCustom($conversationId: ID!, $userId: ID!) {
    deleteConversationCustom(conversationId: $conversationId, userId: $userId)
  }
`;
export const inviteToGroup = /* GraphQL */ `
  mutation InviteToGroup($input: CreateGroupInvitationInput!) {
    inviteToGroup(input: $input) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const respondToInvitation = /* GraphQL */ `
  mutation RespondToInvitation($input: RespondToInvitationInput!) {
    respondToInvitation(input: $input) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const addReaction = /* GraphQL */ `
  mutation AddReaction($messageId: ID!, $emoji: String!, $userId: ID!) {
    addReaction(messageId: $messageId, emoji: $emoji, userId: $userId) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const searchMessages = /* GraphQL */ `
  mutation SearchMessages($conversationId: ID!, $query: String!, $limit: Int) {
    searchMessages(
      conversationId: $conversationId
      query: $query
      limit: $limit
    ) {
      items {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const publishTypingStatus = /* GraphQL */ `
  mutation PublishTypingStatus(
    $conversationID: ID!
    $userID: ID!
    $isTyping: Boolean!
  ) {
    publishTypingStatus(
      conversationID: $conversationID
      userID: $userID
      isTyping: $isTyping
    ) {
      conversationID
      userID
      isTyping
      __typename
    }
  }
`;
export const createNotificationWithEvent = /* GraphQL */ `
  mutation CreateNotificationWithEvent($input: CreateNotificationInput!) {
    createNotificationWithEvent(input: $input) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updatePresenceWithEvent = /* GraphQL */ `
  mutation UpdatePresenceWithEvent($input: UpdatePresenceInput!) {
    updatePresenceWithEvent(input: $input) {
      id
      userID
      status
      lastSeen
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const toggleReviewLike = /* GraphQL */ `
  mutation ToggleReviewLike($reviewID: ID!, $reviewType: String!) {
    toggleReviewLike(reviewID: $reviewID, reviewType: $reviewType) {
      id
      reviewID
      userID
      reviewType
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const toggleBookmark = /* GraphQL */ `
  mutation ToggleBookmark($postID: ID!) {
    toggleBookmark(postID: $postID) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const toggleReviewBookmark = /* GraphQL */ `
  mutation ToggleReviewBookmark($reviewID: ID!, $reviewType: String!) {
    toggleReviewBookmark(reviewID: $reviewID, reviewType: $reviewType) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const processAchievements = /* GraphQL */ `
  mutation ProcessAchievements(
    $userID: ID!
    $actionType: String!
    $metadata: AWSJSON
  ) {
    processAchievements(
      userID: $userID
      actionType: $actionType
      metadata: $metadata
    ) {
      id
      userID
      achievementType
      achievementName
      type
      unlocked
      unlockedAt
      progress
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const shareAchievement = /* GraphQL */ `
  mutation ShareAchievement($achievementID: ID!) {
    shareAchievement(achievementID: $achievementID) {
      id
      userID
      achievementID
      content
      likesCount
      commentsCount
      sharesCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const adminInstantUnlock = /* GraphQL */ `
  mutation AdminInstantUnlock($input: AdminInstantUnlockInput!) {
    adminInstantUnlock(input: $input) {
      success
      message
      affectedUsers
      logId
      __typename
    }
  }
`;
export const adminProgressBoost = /* GraphQL */ `
  mutation AdminProgressBoost($input: AdminProgressBoostInput!) {
    adminProgressBoost(input: $input) {
      success
      message
      affectedUsers
      logId
      __typename
    }
  }
`;
export const adminStatManipulation = /* GraphQL */ `
  mutation AdminStatManipulation($input: AdminStatManipulationInput!) {
    adminStatManipulation(input: $input) {
      success
      message
      affectedUsers
      logId
      __typename
    }
  }
`;
export const adminGlobalBoost = /* GraphQL */ `
  mutation AdminGlobalBoost($input: AdminGlobalBoostInput!) {
    adminGlobalBoost(input: $input) {
      success
      message
      affectedUsers
      logId
      __typename
    }
  }
`;
export const adminBulkUnlock = /* GraphQL */ `
  mutation AdminBulkUnlock($input: AdminBulkUnlockInput!) {
    adminBulkUnlock(input: $input) {
      success
      message
      affectedUsers
      logId
      __typename
    }
  }
`;
export const calculateAchievementProgress = /* GraphQL */ `
  mutation CalculateAchievementProgress(
    $input: CalculateAchievementProgressInput!
  ) {
    calculateAchievementProgress(input: $input) {
      success
      userId
      newlyUnlocked {
        id
        userID
        achievementType
        achievementName
        type
        unlocked
        unlockedAt
        progress
        metadata
        createdAt
        updatedAt
        __typename
      }
      multiplierApplied
      timestamp
      __typename
    }
  }
`;
export const checkAchievementUnlock = /* GraphQL */ `
  mutation CheckAchievementUnlock($input: CheckAchievementUnlockInput!) {
    checkAchievementUnlock(input: $input) {
      success
      unlocked
      alreadyUnlocked
      achievement {
        id
        userID
        achievementType
        achievementName
        type
        unlocked
        unlockedAt
        progress
        metadata
        createdAt
        updatedAt
        __typename
      }
      badgeGranted
      message
      __typename
    }
  }
`;
export const grantUserBadge = /* GraphQL */ `
  mutation GrantUserBadge($input: GrantUserBadgeInput!) {
    grantUserBadge(input: $input) {
      success
      granted
      alreadyGranted
      badge {
        id
        userID
        badgeType
        earnedAt
        metadata
        createdAt
        updatedAt
        __typename
      }
      badgeDefinition {
        id
        type
        name
        description
        icon
        color
        rarity
        points
        isActive
        autoAssign
        conditions
        createdAt
        updatedAt
        __typename
      }
      message
      __typename
    }
  }
`;
export const updateUserTitle = /* GraphQL */ `
  mutation UpdateUserTitle($input: UpdateUserTitleInput!) {
    updateUserTitle(input: $input) {
      success
      titleChanged
      previousTitle
      newTitle
      titleName
      titleDescription
      titleColor
      achievementCount
      totalPoints
      message
      __typename
    }
  }
`;
export const processAchievementPost = /* GraphQL */ `
  mutation ProcessAchievementPost($input: ProcessAchievementPostInput!) {
    processAchievementPost(input: $input) {
      success
      achievementPost {
        id
        userID
        achievementID
        content
        likesCount
        commentsCount
        sharesCount
        createdAt
        updatedAt
        __typename
      }
      sharedToFeed
      socialPostCreated
      message
      __typename
    }
  }
`;
export const auditCheatAction = /* GraphQL */ `
  mutation AuditCheatAction($input: AuditCheatActionInput!) {
    auditCheatAction(input: $input) {
      success
      auditLog {
        id
        type
        adminUserID
        reason
        metadata
        affectedUserID
        timestamp
        ipAddress
        userAgent
        createdAt
        updatedAt
        __typename
      }
      securityAlert {
        id
        adminUserId
        alertType
        message
        severity
        timestamp
        __typename
      }
      recentActionCount
      message
      __typename
    }
  }
`;
export const blockUser = /* GraphQL */ `
  mutation BlockUser($blockedUserID: ID!, $reason: String) {
    blockUser(blockedUserID: $blockedUserID, reason: $reason) {
      success
      blockedUser {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      message
      __typename
    }
  }
`;
export const unblockUser = /* GraphQL */ `
  mutation UnblockUser($blockedUserID: ID!) {
    unblockUser(blockedUserID: $blockedUserID) {
      success
      message
      __typename
    }
  }
`;
export const getBlockedUsers = /* GraphQL */ `
  mutation GetBlockedUsers($limit: Int, $nextToken: String) {
    getBlockedUsers(limit: $limit, nextToken: $nextToken) {
      success
      blockedUsers {
        id
        blockerID
        blockedID
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      message
      __typename
    }
  }
`;
export const manageUserReport = /* GraphQL */ `
  mutation ManageUserReport($input: ManageUserReportInput!) {
    manageUserReport(input: $input) {
      success
      report {
        id
        reporterID
        reportedUserID
        messageID
        reason
        description
        category
        status
        adminNotes
        reviewedBy
        reviewedAt
        createdAt
        updatedAt
        __typename
      }
      message
      __typename
    }
  }
`;
export const manageMuteUser = /* GraphQL */ `
  mutation ManageMuteUser($input: ManageMuteInput!) {
    manageMuteUser(input: $input) {
      success
      mutedUser {
        id
        muterID
        mutedUserID
        duration
        expiresAt
        reason
        createdAt
        updatedAt
        __typename
      }
      message
      __typename
    }
  }
`;
export const toggleNewsBookmark = /* GraphQL */ `
  mutation ToggleNewsBookmark($newsID: ID!) {
    toggleNewsBookmark(newsID: $newsID) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      username
      identityId
      username_lowercase
      email
      displayName
      displayName_lowercase
      avatar
      coverPhoto
      bio
      website
      location
      role
      followersCount
      followingCount
      postsCount
      watchlistPublic
      interests
      languagePreferences
      verified
      totalAchievementPoints
      titles
      titleOrder
      titleUpdatedAt
      titleSource
      activeBadges
      badgeDisplaySettings
      reviewsCount
      likesReceived
      moviesWatched
      earlyDiscoveries
      loginStreak
      lastLoginDate
      createdAt
      updatedAt
      posts {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      following {
        nextToken
        __typename
      }
      userWatchlists {
        nextToken
        __typename
      }
      userWatchlistItems {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      movieInteractions {
        nextToken
        __typename
      }
      showInteractions {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      conversationsAsUser2 {
        nextToken
        __typename
      }
      groupParticipations {
        nextToken
        __typename
      }
      sentInvitations {
        nextToken
        __typename
      }
      receivedInvitations {
        nextToken
        __typename
      }
      postReports {
        nextToken
        __typename
      }
      movieReports {
        nextToken
        __typename
      }
      showReports {
        nextToken
        __typename
      }
      movieReviews {
        nextToken
        __typename
      }
      showReviews {
        nextToken
        __typename
      }
      reviewReports {
        nextToken
        __typename
      }
      reviewLikes {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      achievementPosts {
        nextToken
        __typename
      }
      progressBoosts {
        nextToken
        __typename
      }
      achievementNotifications {
        nextToken
        __typename
      }
      titleHistory {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      blockedByUsers {
        nextToken
        __typename
      }
      reportsMade {
        nextToken
        __typename
      }
      reportsReceived {
        nextToken
        __typename
      }
      mutedUsers {
        nextToken
        __typename
      }
      mutedByUsers {
        nextToken
        __typename
      }
      newsBookmarks {
        nextToken
        __typename
      }
      newsViews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      identityId
      username_lowercase
      email
      displayName
      displayName_lowercase
      avatar
      coverPhoto
      bio
      website
      location
      role
      followersCount
      followingCount
      postsCount
      watchlistPublic
      interests
      languagePreferences
      verified
      totalAchievementPoints
      titles
      titleOrder
      titleUpdatedAt
      titleSource
      activeBadges
      badgeDisplaySettings
      reviewsCount
      likesReceived
      moviesWatched
      earlyDiscoveries
      loginStreak
      lastLoginDate
      createdAt
      updatedAt
      posts {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      following {
        nextToken
        __typename
      }
      userWatchlists {
        nextToken
        __typename
      }
      userWatchlistItems {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      movieInteractions {
        nextToken
        __typename
      }
      showInteractions {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      conversationsAsUser2 {
        nextToken
        __typename
      }
      groupParticipations {
        nextToken
        __typename
      }
      sentInvitations {
        nextToken
        __typename
      }
      receivedInvitations {
        nextToken
        __typename
      }
      postReports {
        nextToken
        __typename
      }
      movieReports {
        nextToken
        __typename
      }
      showReports {
        nextToken
        __typename
      }
      movieReviews {
        nextToken
        __typename
      }
      showReviews {
        nextToken
        __typename
      }
      reviewReports {
        nextToken
        __typename
      }
      reviewLikes {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      achievementPosts {
        nextToken
        __typename
      }
      progressBoosts {
        nextToken
        __typename
      }
      achievementNotifications {
        nextToken
        __typename
      }
      titleHistory {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      blockedByUsers {
        nextToken
        __typename
      }
      reportsMade {
        nextToken
        __typename
      }
      reportsReceived {
        nextToken
        __typename
      }
      mutedUsers {
        nextToken
        __typename
      }
      mutedByUsers {
        nextToken
        __typename
      }
      newsBookmarks {
        nextToken
        __typename
      }
      newsViews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      username
      identityId
      username_lowercase
      email
      displayName
      displayName_lowercase
      avatar
      coverPhoto
      bio
      website
      location
      role
      followersCount
      followingCount
      postsCount
      watchlistPublic
      interests
      languagePreferences
      verified
      totalAchievementPoints
      titles
      titleOrder
      titleUpdatedAt
      titleSource
      activeBadges
      badgeDisplaySettings
      reviewsCount
      likesReceived
      moviesWatched
      earlyDiscoveries
      loginStreak
      lastLoginDate
      createdAt
      updatedAt
      posts {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      following {
        nextToken
        __typename
      }
      userWatchlists {
        nextToken
        __typename
      }
      userWatchlistItems {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      movieInteractions {
        nextToken
        __typename
      }
      showInteractions {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      conversationsAsUser2 {
        nextToken
        __typename
      }
      groupParticipations {
        nextToken
        __typename
      }
      sentInvitations {
        nextToken
        __typename
      }
      receivedInvitations {
        nextToken
        __typename
      }
      postReports {
        nextToken
        __typename
      }
      movieReports {
        nextToken
        __typename
      }
      showReports {
        nextToken
        __typename
      }
      movieReviews {
        nextToken
        __typename
      }
      showReviews {
        nextToken
        __typename
      }
      reviewReports {
        nextToken
        __typename
      }
      reviewLikes {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      achievements {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      achievementPosts {
        nextToken
        __typename
      }
      progressBoosts {
        nextToken
        __typename
      }
      achievementNotifications {
        nextToken
        __typename
      }
      titleHistory {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      blockedByUsers {
        nextToken
        __typename
      }
      reportsMade {
        nextToken
        __typename
      }
      reportsReceived {
        nextToken
        __typename
      }
      mutedUsers {
        nextToken
        __typename
      }
      mutedByUsers {
        nextToken
        __typename
      }
      newsBookmarks {
        nextToken
        __typename
      }
      newsViews {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUserPresence = /* GraphQL */ `
  mutation CreateUserPresence(
    $input: CreateUserPresenceInput!
    $condition: ModelUserPresenceConditionInput
  ) {
    createUserPresence(input: $input, condition: $condition) {
      id
      userID
      status
      lastSeen
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserPresence = /* GraphQL */ `
  mutation UpdateUserPresence(
    $input: UpdateUserPresenceInput!
    $condition: ModelUserPresenceConditionInput
  ) {
    updateUserPresence(input: $input, condition: $condition) {
      id
      userID
      status
      lastSeen
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserPresence = /* GraphQL */ `
  mutation DeleteUserPresence(
    $input: DeleteUserPresenceInput!
    $condition: ModelUserPresenceConditionInput
  ) {
    deleteUserPresence(input: $input, condition: $condition) {
      id
      userID
      status
      lastSeen
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFollow = /* GraphQL */ `
  mutation CreateFollow(
    $input: CreateFollowInput!
    $condition: ModelFollowConditionInput
  ) {
    createFollow(input: $input, condition: $condition) {
      id
      followerID
      followeeID
      createdAt
      followee {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateFollow = /* GraphQL */ `
  mutation UpdateFollow(
    $input: UpdateFollowInput!
    $condition: ModelFollowConditionInput
  ) {
    updateFollow(input: $input, condition: $condition) {
      id
      followerID
      followeeID
      createdAt
      followee {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteFollow = /* GraphQL */ `
  mutation DeleteFollow(
    $input: DeleteFollowInput!
    $condition: ModelFollowConditionInput
  ) {
    deleteFollow(input: $input, condition: $condition) {
      id
      followerID
      followeeID
      createdAt
      followee {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createPost = /* GraphQL */ `
  mutation CreatePost(
    $input: CreatePostInput!
    $condition: ModelPostConditionInput
  ) {
    createPost(input: $input, condition: $condition) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updatePost = /* GraphQL */ `
  mutation UpdatePost(
    $input: UpdatePostInput!
    $condition: ModelPostConditionInput
  ) {
    updatePost(input: $input, condition: $condition) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deletePost = /* GraphQL */ `
  mutation DeletePost(
    $input: DeletePostInput!
    $condition: ModelPostConditionInput
  ) {
    deletePost(input: $input, condition: $condition) {
      id
      type
      authorID
      authorIdentityId
      content
      images
      video
      links
      hashtags
      visibility
      likesCount
      commentsCount
      sharesCount
      isReshare
      originalPostID
      reshareMessage
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      likes {
        nextToken
        __typename
      }
      feedItems {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      shares {
        nextToken
        __typename
      }
      bookmarks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      postID
      authorID
      content
      parentID
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createLike = /* GraphQL */ `
  mutation CreateLike(
    $input: CreateLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    createLike(input: $input, condition: $condition) {
      id
      postID
      userID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateLike = /* GraphQL */ `
  mutation UpdateLike(
    $input: UpdateLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    updateLike(input: $input, condition: $condition) {
      id
      postID
      userID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteLike = /* GraphQL */ `
  mutation DeleteLike(
    $input: DeleteLikeInput!
    $condition: ModelLikeConditionInput
  ) {
    deleteLike(input: $input, condition: $condition) {
      id
      postID
      userID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createShare = /* GraphQL */ `
  mutation CreateShare(
    $input: CreateShareInput!
    $condition: ModelShareConditionInput
  ) {
    createShare(input: $input, condition: $condition) {
      id
      postID
      userID
      message
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateShare = /* GraphQL */ `
  mutation UpdateShare(
    $input: UpdateShareInput!
    $condition: ModelShareConditionInput
  ) {
    updateShare(input: $input, condition: $condition) {
      id
      postID
      userID
      message
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteShare = /* GraphQL */ `
  mutation DeleteShare(
    $input: DeleteShareInput!
    $condition: ModelShareConditionInput
  ) {
    deleteShare(input: $input, condition: $condition) {
      id
      postID
      userID
      message
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createBookmark = /* GraphQL */ `
  mutation CreateBookmark(
    $input: CreateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    createBookmark(input: $input, condition: $condition) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateBookmark = /* GraphQL */ `
  mutation UpdateBookmark(
    $input: UpdateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    updateBookmark(input: $input, condition: $condition) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteBookmark = /* GraphQL */ `
  mutation DeleteBookmark(
    $input: DeleteBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    deleteBookmark(input: $input, condition: $condition) {
      id
      postID
      reviewID
      userID
      contentType
      reviewType
      notes
      tags
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createFeedItem = /* GraphQL */ `
  mutation CreateFeedItem(
    $input: CreateFeedItemInput!
    $condition: ModelFeedItemConditionInput
  ) {
    createFeedItem(input: $input, condition: $condition) {
      id
      userID
      postID
      postOwnerID
      createdAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateFeedItem = /* GraphQL */ `
  mutation UpdateFeedItem(
    $input: UpdateFeedItemInput!
    $condition: ModelFeedItemConditionInput
  ) {
    updateFeedItem(input: $input, condition: $condition) {
      id
      userID
      postID
      postOwnerID
      createdAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteFeedItem = /* GraphQL */ `
  mutation DeleteFeedItem(
    $input: DeleteFeedItemInput!
    $condition: ModelFeedItemConditionInput
  ) {
    deleteFeedItem(input: $input, condition: $condition) {
      id
      userID
      postID
      postOwnerID
      createdAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createMovie = /* GraphQL */ `
  mutation CreateMovie(
    $input: CreateMovieInput!
    $condition: ModelMovieConditionInput
  ) {
    createMovie(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMovie = /* GraphQL */ `
  mutation UpdateMovie(
    $input: UpdateMovieInput!
    $condition: ModelMovieConditionInput
  ) {
    updateMovie(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMovie = /* GraphQL */ `
  mutation DeleteMovie(
    $input: DeleteMovieInput!
    $condition: ModelMovieConditionInput
  ) {
    deleteMovie(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      watchlistItems {
        nextToken
        __typename
      }
      watched {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserWatchlist = /* GraphQL */ `
  mutation CreateUserWatchlist(
    $input: CreateUserWatchlistInput!
    $condition: ModelUserWatchlistConditionInput
  ) {
    createUserWatchlist(input: $input, condition: $condition) {
      id
      userID
      name
      description
      isDefault
      isPublic
      itemCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      items {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateUserWatchlist = /* GraphQL */ `
  mutation UpdateUserWatchlist(
    $input: UpdateUserWatchlistInput!
    $condition: ModelUserWatchlistConditionInput
  ) {
    updateUserWatchlist(input: $input, condition: $condition) {
      id
      userID
      name
      description
      isDefault
      isPublic
      itemCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      items {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserWatchlist = /* GraphQL */ `
  mutation DeleteUserWatchlist(
    $input: DeleteUserWatchlistInput!
    $condition: ModelUserWatchlistConditionInput
  ) {
    deleteUserWatchlist(input: $input, condition: $condition) {
      id
      userID
      name
      description
      isDefault
      isPublic
      itemCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      items {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createWatchlistItem = /* GraphQL */ `
  mutation CreateWatchlistItem(
    $input: CreateWatchlistItemInput!
    $condition: ModelWatchlistItemConditionInput
  ) {
    createWatchlistItem(input: $input, condition: $condition) {
      id
      userID
      watchlistID
      movieID
      showID
      contentType
      status
      priority
      notes
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      watchlist {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateWatchlistItem = /* GraphQL */ `
  mutation UpdateWatchlistItem(
    $input: UpdateWatchlistItemInput!
    $condition: ModelWatchlistItemConditionInput
  ) {
    updateWatchlistItem(input: $input, condition: $condition) {
      id
      userID
      watchlistID
      movieID
      showID
      contentType
      status
      priority
      notes
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      watchlist {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteWatchlistItem = /* GraphQL */ `
  mutation DeleteWatchlistItem(
    $input: DeleteWatchlistItemInput!
    $condition: ModelWatchlistItemConditionInput
  ) {
    deleteWatchlistItem(input: $input, condition: $condition) {
      id
      userID
      watchlistID
      movieID
      showID
      contentType
      status
      priority
      notes
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      watchlist {
        id
        userID
        name
        description
        isDefault
        isPublic
        itemCount
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createWatchedItem = /* GraphQL */ `
  mutation CreateWatchedItem(
    $input: CreateWatchedItemInput!
    $condition: ModelWatchedItemConditionInput
  ) {
    createWatchedItem(input: $input, condition: $condition) {
      id
      userID
      movieID
      status
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateWatchedItem = /* GraphQL */ `
  mutation UpdateWatchedItem(
    $input: UpdateWatchedItemInput!
    $condition: ModelWatchedItemConditionInput
  ) {
    updateWatchedItem(input: $input, condition: $condition) {
      id
      userID
      movieID
      status
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteWatchedItem = /* GraphQL */ `
  mutation DeleteWatchedItem(
    $input: DeleteWatchedItemInput!
    $condition: ModelWatchedItemConditionInput
  ) {
    deleteWatchedItem(input: $input, condition: $condition) {
      id
      userID
      movieID
      status
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createUserMovieInteraction = /* GraphQL */ `
  mutation CreateUserMovieInteraction(
    $input: CreateUserMovieInteractionInput!
    $condition: ModelUserMovieInteractionConditionInput
  ) {
    createUserMovieInteraction(input: $input, condition: $condition) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateUserMovieInteraction = /* GraphQL */ `
  mutation UpdateUserMovieInteraction(
    $input: UpdateUserMovieInteractionInput!
    $condition: ModelUserMovieInteractionConditionInput
  ) {
    updateUserMovieInteraction(input: $input, condition: $condition) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserMovieInteraction = /* GraphQL */ `
  mutation DeleteUserMovieInteraction(
    $input: DeleteUserMovieInteractionInput!
    $condition: ModelUserMovieInteractionConditionInput
  ) {
    deleteUserMovieInteraction(input: $input, condition: $condition) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createShow = /* GraphQL */ `
  mutation CreateShow(
    $input: CreateShowInput!
    $condition: ModelShowConditionInput
  ) {
    createShow(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      watchlistItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateShow = /* GraphQL */ `
  mutation UpdateShow(
    $input: UpdateShowInput!
    $condition: ModelShowConditionInput
  ) {
    updateShow(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      watchlistItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteShow = /* GraphQL */ `
  mutation DeleteShow(
    $input: DeleteShowInput!
    $condition: ModelShowConditionInput
  ) {
    deleteShow(input: $input, condition: $condition) {
      id
      name
      poster
      content_type
      genre
      hero
      heroine
      director
      music
      screenplay
      editor
      cameraman
      language
      summary
      rating
      hypeRating
      hypeScore
      hypeBreakdown
      totalInteractions
      viewCount
      watchlistCount
      watchedCount
      reviewCount
      shareCount
      ottClickCount
      reviewLikeCount
      release_date
      ott_release_date
      popularity
      trending
      created_at
      updated_at
      interactions {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      reviews {
        nextToken
        __typename
      }
      watchlistItems {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserShowInteraction = /* GraphQL */ `
  mutation CreateUserShowInteraction(
    $input: CreateUserShowInteractionInput!
    $condition: ModelUserShowInteractionConditionInput
  ) {
    createUserShowInteraction(input: $input, condition: $condition) {
      id
      userID
      showID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateUserShowInteraction = /* GraphQL */ `
  mutation UpdateUserShowInteraction(
    $input: UpdateUserShowInteractionInput!
    $condition: ModelUserShowInteractionConditionInput
  ) {
    updateUserShowInteraction(input: $input, condition: $condition) {
      id
      userID
      showID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserShowInteraction = /* GraphQL */ `
  mutation DeleteUserShowInteraction(
    $input: DeleteUserShowInteractionInput!
    $condition: ModelUserShowInteractionConditionInput
  ) {
    deleteUserShowInteraction(input: $input, condition: $condition) {
      id
      userID
      showID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      userRating
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      userID
      type
      message
      isRead
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation(
    $input: DeleteConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    deleteConversation(input: $input, condition: $condition) {
      id
      user1ID
      user2ID
      isGroup
      groupName
      groupDescription
      groupAvatar
      createdBy
      lastMessageID
      lastMessageText
      lastMessageAt
      user1UnreadCount
      user2UnreadCount
      user1Archived
      user2Archived
      user1ArchivedAt
      user2ArchivedAt
      autoLockEnabled
      lockDuration
      lockedAt
      createdAt
      updatedAt
      user1 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      user2 {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      creator {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      invitations {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createGroupParticipant = /* GraphQL */ `
  mutation CreateGroupParticipant(
    $input: CreateGroupParticipantInput!
    $condition: ModelGroupParticipantConditionInput
  ) {
    createGroupParticipant(input: $input, condition: $condition) {
      id
      conversationID
      userID
      role
      joinedAt
      leftAt
      unreadCount
      archived
      archivedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGroupParticipant = /* GraphQL */ `
  mutation UpdateGroupParticipant(
    $input: UpdateGroupParticipantInput!
    $condition: ModelGroupParticipantConditionInput
  ) {
    updateGroupParticipant(input: $input, condition: $condition) {
      id
      conversationID
      userID
      role
      joinedAt
      leftAt
      unreadCount
      archived
      archivedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGroupParticipant = /* GraphQL */ `
  mutation DeleteGroupParticipant(
    $input: DeleteGroupParticipantInput!
    $condition: ModelGroupParticipantConditionInput
  ) {
    deleteGroupParticipant(input: $input, condition: $condition) {
      id
      conversationID
      userID
      role
      joinedAt
      leftAt
      unreadCount
      archived
      archivedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGroupInvitation = /* GraphQL */ `
  mutation CreateGroupInvitation(
    $input: CreateGroupInvitationInput!
    $condition: ModelGroupInvitationConditionInput
  ) {
    createGroupInvitation(input: $input, condition: $condition) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateGroupInvitation = /* GraphQL */ `
  mutation UpdateGroupInvitation(
    $input: UpdateGroupInvitationInput!
    $condition: ModelGroupInvitationConditionInput
  ) {
    updateGroupInvitation(input: $input, condition: $condition) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteGroupInvitation = /* GraphQL */ `
  mutation DeleteGroupInvitation(
    $input: DeleteGroupInvitationInput!
    $condition: ModelGroupInvitationConditionInput
  ) {
    deleteGroupInvitation(input: $input, condition: $condition) {
      id
      conversationID
      invitedUserID
      invitedBy
      status
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      invitedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      inviter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createReviewReport = /* GraphQL */ `
  mutation CreateReviewReport(
    $input: CreateReviewReportInput!
    $condition: ModelReviewReportConditionInput
  ) {
    createReviewReport(input: $input, condition: $condition) {
      id
      reviewID
      reviewType
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateReviewReport = /* GraphQL */ `
  mutation UpdateReviewReport(
    $input: UpdateReviewReportInput!
    $condition: ModelReviewReportConditionInput
  ) {
    updateReviewReport(input: $input, condition: $condition) {
      id
      reviewID
      reviewType
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteReviewReport = /* GraphQL */ `
  mutation DeleteReviewReport(
    $input: DeleteReviewReportInput!
    $condition: ModelReviewReportConditionInput
  ) {
    deleteReviewReport(input: $input, condition: $condition) {
      id
      reviewID
      reviewType
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createPostReport = /* GraphQL */ `
  mutation CreatePostReport(
    $input: CreatePostReportInput!
    $condition: ModelPostReportConditionInput
  ) {
    createPostReport(input: $input, condition: $condition) {
      id
      postID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updatePostReport = /* GraphQL */ `
  mutation UpdatePostReport(
    $input: UpdatePostReportInput!
    $condition: ModelPostReportConditionInput
  ) {
    updatePostReport(input: $input, condition: $condition) {
      id
      postID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deletePostReport = /* GraphQL */ `
  mutation DeletePostReport(
    $input: DeletePostReportInput!
    $condition: ModelPostReportConditionInput
  ) {
    deletePostReport(input: $input, condition: $condition) {
      id
      postID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      post {
        id
        type
        authorID
        authorIdentityId
        content
        images
        video
        links
        hashtags
        visibility
        likesCount
        commentsCount
        sharesCount
        isReshare
        originalPostID
        reshareMessage
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createMovieReport = /* GraphQL */ `
  mutation CreateMovieReport(
    $input: CreateMovieReportInput!
    $condition: ModelMovieReportConditionInput
  ) {
    createMovieReport(input: $input, condition: $condition) {
      id
      movieID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateMovieReport = /* GraphQL */ `
  mutation UpdateMovieReport(
    $input: UpdateMovieReportInput!
    $condition: ModelMovieReportConditionInput
  ) {
    updateMovieReport(input: $input, condition: $condition) {
      id
      movieID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteMovieReport = /* GraphQL */ `
  mutation DeleteMovieReport(
    $input: DeleteMovieReportInput!
    $condition: ModelMovieReportConditionInput
  ) {
    deleteMovieReport(input: $input, condition: $condition) {
      id
      movieID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      movie {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createShowReport = /* GraphQL */ `
  mutation CreateShowReport(
    $input: CreateShowReportInput!
    $condition: ModelShowReportConditionInput
  ) {
    createShowReport(input: $input, condition: $condition) {
      id
      showID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateShowReport = /* GraphQL */ `
  mutation UpdateShowReport(
    $input: UpdateShowReportInput!
    $condition: ModelShowReportConditionInput
  ) {
    updateShowReport(input: $input, condition: $condition) {
      id
      showID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteShowReport = /* GraphQL */ `
  mutation DeleteShowReport(
    $input: DeleteShowReportInput!
    $condition: ModelShowReportConditionInput
  ) {
    deleteShowReport(input: $input, condition: $condition) {
      id
      showID
      reportedBy
      reason
      description
      status
      createdAt
      updatedAt
      show {
        id
        name
        poster
        content_type
        genre
        hero
        heroine
        director
        music
        screenplay
        editor
        cameraman
        language
        summary
        rating
        hypeRating
        hypeScore
        hypeBreakdown
        totalInteractions
        viewCount
        watchlistCount
        watchedCount
        reviewCount
        shareCount
        ottClickCount
        reviewLikeCount
        release_date
        ott_release_date
        popularity
        trending
        created_at
        updated_at
        createdAt
        updatedAt
        __typename
      }
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createMovieReview = /* GraphQL */ `
  mutation CreateMovieReview(
    $input: CreateMovieReviewInput!
    $condition: ModelMovieReviewConditionInput
  ) {
    createMovieReview(input: $input, condition: $condition) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const updateMovieReview = /* GraphQL */ `
  mutation UpdateMovieReview(
    $input: UpdateMovieReviewInput!
    $condition: ModelMovieReviewConditionInput
  ) {
    updateMovieReview(input: $input, condition: $condition) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const deleteMovieReview = /* GraphQL */ `
  mutation DeleteMovieReview(
    $input: DeleteMovieReviewInput!
    $condition: ModelMovieReviewConditionInput
  ) {
    deleteMovieReview(input: $input, condition: $condition) {
      id
      movieID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const createShowReview = /* GraphQL */ `
  mutation CreateShowReview(
    $input: CreateShowReviewInput!
    $condition: ModelShowReviewConditionInput
  ) {
    createShowReview(input: $input, condition: $condition) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const updateShowReview = /* GraphQL */ `
  mutation UpdateShowReview(
    $input: UpdateShowReviewInput!
    $condition: ModelShowReviewConditionInput
  ) {
    updateShowReview(input: $input, condition: $condition) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const deleteShowReview = /* GraphQL */ `
  mutation DeleteShowReview(
    $input: DeleteShowReviewInput!
    $condition: ModelShowReviewConditionInput
  ) {
    deleteShowReview(input: $input, condition: $condition) {
      id
      showID
      authorID
      rating
      review
      ratingSystem
      emoji
      status
      createdAt
      updatedAt
      author {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reports {
        nextToken
        __typename
      }
      likesCount
      __typename
    }
  }
`;
export const createReviewLike = /* GraphQL */ `
  mutation CreateReviewLike(
    $input: CreateReviewLikeInput!
    $condition: ModelReviewLikeConditionInput
  ) {
    createReviewLike(input: $input, condition: $condition) {
      id
      reviewID
      userID
      reviewType
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateReviewLike = /* GraphQL */ `
  mutation UpdateReviewLike(
    $input: UpdateReviewLikeInput!
    $condition: ModelReviewLikeConditionInput
  ) {
    updateReviewLike(input: $input, condition: $condition) {
      id
      reviewID
      userID
      reviewType
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteReviewLike = /* GraphQL */ `
  mutation DeleteReviewLike(
    $input: DeleteReviewLikeInput!
    $condition: ModelReviewLikeConditionInput
  ) {
    deleteReviewLike(input: $input, condition: $condition) {
      id
      reviewID
      userID
      reviewType
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      content
      messageType
      isRead
      replyToMessageId
      reactions
      createdAt
      updatedAt
      conversation {
        id
        user1ID
        user2ID
        isGroup
        groupName
        groupDescription
        groupAvatar
        createdBy
        lastMessageID
        lastMessageText
        lastMessageAt
        user1UnreadCount
        user2UnreadCount
        user1Archived
        user2Archived
        user1ArchivedAt
        user2ArchivedAt
        autoLockEnabled
        lockDuration
        lockedAt
        createdAt
        updatedAt
        __typename
      }
      sender {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      receiver {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      replyToMessage {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      reports {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCheatLog = /* GraphQL */ `
  mutation CreateCheatLog(
    $input: CreateCheatLogInput!
    $condition: ModelCheatLogConditionInput
  ) {
    createCheatLog(input: $input, condition: $condition) {
      id
      type
      adminUserID
      reason
      metadata
      affectedUserID
      timestamp
      ipAddress
      userAgent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCheatLog = /* GraphQL */ `
  mutation UpdateCheatLog(
    $input: UpdateCheatLogInput!
    $condition: ModelCheatLogConditionInput
  ) {
    updateCheatLog(input: $input, condition: $condition) {
      id
      type
      adminUserID
      reason
      metadata
      affectedUserID
      timestamp
      ipAddress
      userAgent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCheatLog = /* GraphQL */ `
  mutation DeleteCheatLog(
    $input: DeleteCheatLogInput!
    $condition: ModelCheatLogConditionInput
  ) {
    deleteCheatLog(input: $input, condition: $condition) {
      id
      type
      adminUserID
      reason
      metadata
      affectedUserID
      timestamp
      ipAddress
      userAgent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGlobalBoostConfig = /* GraphQL */ `
  mutation CreateGlobalBoostConfig(
    $input: CreateGlobalBoostConfigInput!
    $condition: ModelGlobalBoostConfigConditionInput
  ) {
    createGlobalBoostConfig(input: $input, condition: $condition) {
      id
      active
      multiplier
      activatedAt
      deactivatedAt
      adminUserID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGlobalBoostConfig = /* GraphQL */ `
  mutation UpdateGlobalBoostConfig(
    $input: UpdateGlobalBoostConfigInput!
    $condition: ModelGlobalBoostConfigConditionInput
  ) {
    updateGlobalBoostConfig(input: $input, condition: $condition) {
      id
      active
      multiplier
      activatedAt
      deactivatedAt
      adminUserID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGlobalBoostConfig = /* GraphQL */ `
  mutation DeleteGlobalBoostConfig(
    $input: DeleteGlobalBoostConfigInput!
    $condition: ModelGlobalBoostConfigConditionInput
  ) {
    deleteGlobalBoostConfig(input: $input, condition: $condition) {
      id
      active
      multiplier
      activatedAt
      deactivatedAt
      adminUserID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserProgressBoost = /* GraphQL */ `
  mutation CreateUserProgressBoost(
    $input: CreateUserProgressBoostInput!
    $condition: ModelUserProgressBoostConditionInput
  ) {
    createUserProgressBoost(input: $input, condition: $condition) {
      id
      userID
      multiplier
      expiresAt
      adminUserID
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateUserProgressBoost = /* GraphQL */ `
  mutation UpdateUserProgressBoost(
    $input: UpdateUserProgressBoostInput!
    $condition: ModelUserProgressBoostConditionInput
  ) {
    updateUserProgressBoost(input: $input, condition: $condition) {
      id
      userID
      multiplier
      expiresAt
      adminUserID
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProgressBoost = /* GraphQL */ `
  mutation DeleteUserProgressBoost(
    $input: DeleteUserProgressBoostInput!
    $condition: ModelUserProgressBoostConditionInput
  ) {
    deleteUserProgressBoost(input: $input, condition: $condition) {
      id
      userID
      multiplier
      expiresAt
      adminUserID
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createAchievementDefinition = /* GraphQL */ `
  mutation CreateAchievementDefinition(
    $input: CreateAchievementDefinitionInput!
    $condition: ModelAchievementDefinitionConditionInput
  ) {
    createAchievementDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      category
      rarity
      points
      icon
      conditions
      conditionType
      targetValue
      targetField
      contentIds
      genreName
      franchiseId
      isActive
      isRepeatable
      maxProgress
      threshold
      badgeType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAchievementDefinition = /* GraphQL */ `
  mutation UpdateAchievementDefinition(
    $input: UpdateAchievementDefinitionInput!
    $condition: ModelAchievementDefinitionConditionInput
  ) {
    updateAchievementDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      category
      rarity
      points
      icon
      conditions
      conditionType
      targetValue
      targetField
      contentIds
      genreName
      franchiseId
      isActive
      isRepeatable
      maxProgress
      threshold
      badgeType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAchievementDefinition = /* GraphQL */ `
  mutation DeleteAchievementDefinition(
    $input: DeleteAchievementDefinitionInput!
    $condition: ModelAchievementDefinitionConditionInput
  ) {
    deleteAchievementDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      category
      rarity
      points
      icon
      conditions
      conditionType
      targetValue
      targetField
      contentIds
      genreName
      franchiseId
      isActive
      isRepeatable
      maxProgress
      threshold
      badgeType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBadgeDefinition = /* GraphQL */ `
  mutation CreateBadgeDefinition(
    $input: CreateBadgeDefinitionInput!
    $condition: ModelBadgeDefinitionConditionInput
  ) {
    createBadgeDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      icon
      color
      rarity
      points
      isActive
      autoAssign
      conditions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBadgeDefinition = /* GraphQL */ `
  mutation UpdateBadgeDefinition(
    $input: UpdateBadgeDefinitionInput!
    $condition: ModelBadgeDefinitionConditionInput
  ) {
    updateBadgeDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      icon
      color
      rarity
      points
      isActive
      autoAssign
      conditions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBadgeDefinition = /* GraphQL */ `
  mutation DeleteBadgeDefinition(
    $input: DeleteBadgeDefinitionInput!
    $condition: ModelBadgeDefinitionConditionInput
  ) {
    deleteBadgeDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      icon
      color
      rarity
      points
      isActive
      autoAssign
      conditions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTitleDefinition = /* GraphQL */ `
  mutation CreateTitleDefinition(
    $input: CreateTitleDefinitionInput!
    $condition: ModelTitleDefinitionConditionInput
  ) {
    createTitleDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      color
      rarity
      minAchievements
      minPoints
      requiredAchievements
      isActive
      isDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTitleDefinition = /* GraphQL */ `
  mutation UpdateTitleDefinition(
    $input: UpdateTitleDefinitionInput!
    $condition: ModelTitleDefinitionConditionInput
  ) {
    updateTitleDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      color
      rarity
      minAchievements
      minPoints
      requiredAchievements
      isActive
      isDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTitleDefinition = /* GraphQL */ `
  mutation DeleteTitleDefinition(
    $input: DeleteTitleDefinitionInput!
    $condition: ModelTitleDefinitionConditionInput
  ) {
    deleteTitleDefinition(input: $input, condition: $condition) {
      id
      type
      name
      description
      color
      rarity
      minAchievements
      minPoints
      requiredAchievements
      isActive
      isDefault
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserAchievement = /* GraphQL */ `
  mutation CreateUserAchievement(
    $input: CreateUserAchievementInput!
    $condition: ModelUserAchievementConditionInput
  ) {
    createUserAchievement(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      type
      unlocked
      unlockedAt
      progress
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateUserAchievement = /* GraphQL */ `
  mutation UpdateUserAchievement(
    $input: UpdateUserAchievementInput!
    $condition: ModelUserAchievementConditionInput
  ) {
    updateUserAchievement(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      type
      unlocked
      unlockedAt
      progress
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserAchievement = /* GraphQL */ `
  mutation DeleteUserAchievement(
    $input: DeleteUserAchievementInput!
    $condition: ModelUserAchievementConditionInput
  ) {
    deleteUserAchievement(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      type
      unlocked
      unlockedAt
      progress
      metadata
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createUserBadge = /* GraphQL */ `
  mutation CreateUserBadge(
    $input: CreateUserBadgeInput!
    $condition: ModelUserBadgeConditionInput
  ) {
    createUserBadge(input: $input, condition: $condition) {
      id
      userID
      badgeType
      earnedAt
      metadata
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserBadge = /* GraphQL */ `
  mutation UpdateUserBadge(
    $input: UpdateUserBadgeInput!
    $condition: ModelUserBadgeConditionInput
  ) {
    updateUserBadge(input: $input, condition: $condition) {
      id
      userID
      badgeType
      earnedAt
      metadata
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserBadge = /* GraphQL */ `
  mutation DeleteUserBadge(
    $input: DeleteUserBadgeInput!
    $condition: ModelUserBadgeConditionInput
  ) {
    deleteUserBadge(input: $input, condition: $condition) {
      id
      userID
      badgeType
      earnedAt
      metadata
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAchievementPost = /* GraphQL */ `
  mutation CreateAchievementPost(
    $input: CreateAchievementPostInput!
    $condition: ModelAchievementPostConditionInput
  ) {
    createAchievementPost(input: $input, condition: $condition) {
      id
      userID
      achievementID
      content
      likesCount
      commentsCount
      sharesCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateAchievementPost = /* GraphQL */ `
  mutation UpdateAchievementPost(
    $input: UpdateAchievementPostInput!
    $condition: ModelAchievementPostConditionInput
  ) {
    updateAchievementPost(input: $input, condition: $condition) {
      id
      userID
      achievementID
      content
      likesCount
      commentsCount
      sharesCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteAchievementPost = /* GraphQL */ `
  mutation DeleteAchievementPost(
    $input: DeleteAchievementPostInput!
    $condition: ModelAchievementPostConditionInput
  ) {
    deleteAchievementPost(input: $input, condition: $condition) {
      id
      userID
      achievementID
      content
      likesCount
      commentsCount
      sharesCount
      createdAt
      updatedAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createAchievementNotification = /* GraphQL */ `
  mutation CreateAchievementNotification(
    $input: CreateAchievementNotificationInput!
    $condition: ModelAchievementNotificationConditionInput
  ) {
    createAchievementNotification(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      notificationType
      title
      message
      icon
      color
      animationType
      soundEffect
      priority
      isRead
      isDisplayed
      displayDuration
      metadata
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateAchievementNotification = /* GraphQL */ `
  mutation UpdateAchievementNotification(
    $input: UpdateAchievementNotificationInput!
    $condition: ModelAchievementNotificationConditionInput
  ) {
    updateAchievementNotification(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      notificationType
      title
      message
      icon
      color
      animationType
      soundEffect
      priority
      isRead
      isDisplayed
      displayDuration
      metadata
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteAchievementNotification = /* GraphQL */ `
  mutation DeleteAchievementNotification(
    $input: DeleteAchievementNotificationInput!
    $condition: ModelAchievementNotificationConditionInput
  ) {
    deleteAchievementNotification(input: $input, condition: $condition) {
      id
      userID
      achievementType
      achievementName
      notificationType
      title
      message
      icon
      color
      animationType
      soundEffect
      priority
      isRead
      isDisplayed
      displayDuration
      metadata
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createUserTitleHistory = /* GraphQL */ `
  mutation CreateUserTitleHistory(
    $input: CreateUserTitleHistoryInput!
    $condition: ModelUserTitleHistoryConditionInput
  ) {
    createUserTitleHistory(input: $input, condition: $condition) {
      id
      userID
      previousTitle
      newTitle
      achievementCount
      totalPoints
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateUserTitleHistory = /* GraphQL */ `
  mutation UpdateUserTitleHistory(
    $input: UpdateUserTitleHistoryInput!
    $condition: ModelUserTitleHistoryConditionInput
  ) {
    updateUserTitleHistory(input: $input, condition: $condition) {
      id
      userID
      previousTitle
      newTitle
      achievementCount
      totalPoints
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteUserTitleHistory = /* GraphQL */ `
  mutation DeleteUserTitleHistory(
    $input: DeleteUserTitleHistoryInput!
    $condition: ModelUserTitleHistoryConditionInput
  ) {
    deleteUserTitleHistory(input: $input, condition: $condition) {
      id
      userID
      previousTitle
      newTitle
      achievementCount
      totalPoints
      reason
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createBlockedUser = /* GraphQL */ `
  mutation CreateBlockedUser(
    $input: CreateBlockedUserInput!
    $condition: ModelBlockedUserConditionInput
  ) {
    createBlockedUser(input: $input, condition: $condition) {
      id
      blockerID
      blockedID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBlockedUser = /* GraphQL */ `
  mutation UpdateBlockedUser(
    $input: UpdateBlockedUserInput!
    $condition: ModelBlockedUserConditionInput
  ) {
    updateBlockedUser(input: $input, condition: $condition) {
      id
      blockerID
      blockedID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBlockedUser = /* GraphQL */ `
  mutation DeleteBlockedUser(
    $input: DeleteBlockedUserInput!
    $condition: ModelBlockedUserConditionInput
  ) {
    deleteBlockedUser(input: $input, condition: $condition) {
      id
      blockerID
      blockedID
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserReport = /* GraphQL */ `
  mutation CreateUserReport(
    $input: CreateUserReportInput!
    $condition: ModelUserReportConditionInput
  ) {
    createUserReport(input: $input, condition: $condition) {
      id
      reporterID
      reportedUserID
      messageID
      reason
      description
      category
      status
      adminNotes
      reviewedBy
      reviewedAt
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reportedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateUserReport = /* GraphQL */ `
  mutation UpdateUserReport(
    $input: UpdateUserReportInput!
    $condition: ModelUserReportConditionInput
  ) {
    updateUserReport(input: $input, condition: $condition) {
      id
      reporterID
      reportedUserID
      messageID
      reason
      description
      category
      status
      adminNotes
      reviewedBy
      reviewedAt
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reportedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteUserReport = /* GraphQL */ `
  mutation DeleteUserReport(
    $input: DeleteUserReportInput!
    $condition: ModelUserReportConditionInput
  ) {
    deleteUserReport(input: $input, condition: $condition) {
      id
      reporterID
      reportedUserID
      messageID
      reason
      description
      category
      status
      adminNotes
      reviewedBy
      reviewedAt
      createdAt
      updatedAt
      reporter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      reportedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      message {
        id
        conversationID
        senderID
        receiverID
        content
        messageType
        isRead
        replyToMessageId
        reactions
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createMutedUser = /* GraphQL */ `
  mutation CreateMutedUser(
    $input: CreateMutedUserInput!
    $condition: ModelMutedUserConditionInput
  ) {
    createMutedUser(input: $input, condition: $condition) {
      id
      muterID
      mutedUserID
      duration
      expiresAt
      reason
      createdAt
      updatedAt
      muter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      mutedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateMutedUser = /* GraphQL */ `
  mutation UpdateMutedUser(
    $input: UpdateMutedUserInput!
    $condition: ModelMutedUserConditionInput
  ) {
    updateMutedUser(input: $input, condition: $condition) {
      id
      muterID
      mutedUserID
      duration
      expiresAt
      reason
      createdAt
      updatedAt
      muter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      mutedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteMutedUser = /* GraphQL */ `
  mutation DeleteMutedUser(
    $input: DeleteMutedUserInput!
    $condition: ModelMutedUserConditionInput
  ) {
    deleteMutedUser(input: $input, condition: $condition) {
      id
      muterID
      mutedUserID
      duration
      expiresAt
      reason
      createdAt
      updatedAt
      muter {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      mutedUser {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createNews = /* GraphQL */ `
  mutation CreateNews(
    $input: CreateNewsInput!
    $condition: ModelNewsConditionInput
  ) {
    createNews(input: $input, condition: $condition) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateNews = /* GraphQL */ `
  mutation UpdateNews(
    $input: UpdateNewsInput!
    $condition: ModelNewsConditionInput
  ) {
    updateNews(input: $input, condition: $condition) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteNews = /* GraphQL */ `
  mutation DeleteNews(
    $input: DeleteNewsInput!
    $condition: ModelNewsConditionInput
  ) {
    deleteNews(input: $input, condition: $condition) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createNewsBookmark = /* GraphQL */ `
  mutation CreateNewsBookmark(
    $input: CreateNewsBookmarkInput!
    $condition: ModelNewsBookmarkConditionInput
  ) {
    createNewsBookmark(input: $input, condition: $condition) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateNewsBookmark = /* GraphQL */ `
  mutation UpdateNewsBookmark(
    $input: UpdateNewsBookmarkInput!
    $condition: ModelNewsBookmarkConditionInput
  ) {
    updateNewsBookmark(input: $input, condition: $condition) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteNewsBookmark = /* GraphQL */ `
  mutation DeleteNewsBookmark(
    $input: DeleteNewsBookmarkInput!
    $condition: ModelNewsBookmarkConditionInput
  ) {
    deleteNewsBookmark(input: $input, condition: $condition) {
      id
      userID
      newsID
      createdAt
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateNewsView = /* GraphQL */ `
  mutation UpdateNewsView(
    $input: UpdateNewsViewInput!
    $condition: ModelNewsViewConditionInput
  ) {
    updateNewsView(input: $input, condition: $condition) {
      id
      newsID
      userID
      sessionID
      ipAddress
      userAgent
      createdAt
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteNewsView = /* GraphQL */ `
  mutation DeleteNewsView(
    $input: DeleteNewsViewInput!
    $condition: ModelNewsViewConditionInput
  ) {
    deleteNewsView(input: $input, condition: $condition) {
      id
      newsID
      userID
      sessionID
      ipAddress
      userAgent
      createdAt
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createInteractionEvent = /* GraphQL */ `
  mutation CreateInteractionEvent(
    $input: CreateInteractionEventInput!
    $condition: ModelInteractionEventConditionInput
  ) {
    createInteractionEvent(input: $input, condition: $condition) {
      id
      userID
      movieID
      showID
      contentType
      action
      sessionID
      deviceType
      platform
      duration
      metadata
      timestamp
      createdAt
      isAnonymous
      ipAddress
      userAgent
      updatedAt
      __typename
    }
  }
`;
export const updateInteractionEvent = /* GraphQL */ `
  mutation UpdateInteractionEvent(
    $input: UpdateInteractionEventInput!
    $condition: ModelInteractionEventConditionInput
  ) {
    updateInteractionEvent(input: $input, condition: $condition) {
      id
      userID
      movieID
      showID
      contentType
      action
      sessionID
      deviceType
      platform
      duration
      metadata
      timestamp
      createdAt
      isAnonymous
      ipAddress
      userAgent
      updatedAt
      __typename
    }
  }
`;
export const deleteInteractionEvent = /* GraphQL */ `
  mutation DeleteInteractionEvent(
    $input: DeleteInteractionEventInput!
    $condition: ModelInteractionEventConditionInput
  ) {
    deleteInteractionEvent(input: $input, condition: $condition) {
      id
      userID
      movieID
      showID
      contentType
      action
      sessionID
      deviceType
      platform
      duration
      metadata
      timestamp
      createdAt
      isAnonymous
      ipAddress
      userAgent
      updatedAt
      __typename
    }
  }
`;
export const createNewsView = /* GraphQL */ `
  mutation CreateNewsView(
    $input: CreateNewsViewInput!
    $condition: ModelNewsViewConditionInput
  ) {
    createNewsView(input: $input, condition: $condition) {
      id
      newsID
      userID
      sessionID
      ipAddress
      userAgent
      createdAt
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const trackInteraction = /* GraphQL */ `
  mutation TrackInteraction($input: TrackInteractionInput!) {
    trackInteraction(input: $input) {
      id
      userID
      movieID
      showID
      contentType
      action
      sessionID
      deviceType
      platform
      duration
      metadata
      timestamp
      createdAt
      isAnonymous
      ipAddress
      userAgent
      updatedAt
      __typename
    }
  }
`;
export const calculateHypeRating = /* GraphQL */ `
  mutation CalculateHypeRating($contentID: ID!, $contentType: String!) {
    calculateHypeRating(contentID: $contentID, contentType: $contentType) {
      contentID
      contentType
      hypeRating
      hypeScore
      breakdown {
        viewScore
        watchlistScore
        watchedScore
        reviewScore
        shareScore
        engagementScore
        recencyBonus
        totalScore
        __typename
      }
      __typename
    }
  }
`;
export const trackNewsView = /* GraphQL */ `
  mutation TrackNewsView(
    $newsID: ID!
    $sessionID: String
    $ipAddress: String
    $userAgent: String
  ) {
    trackNewsView(
      newsID: $newsID
      sessionID: $sessionID
      ipAddress: $ipAddress
      userAgent: $userAgent
    ) {
      id
      newsID
      userID
      sessionID
      ipAddress
      userAgent
      createdAt
      news {
        id
        title
        description
        content
        source
        source_url
        author
        published_at
        featured_image
        tmdb_id
        media_type
        category
        tags
        status
        is_featured
        is_breaking
        created_by
        view_count
        bookmark_count
        share_count
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        username
        identityId
        username_lowercase
        email
        displayName
        displayName_lowercase
        avatar
        coverPhoto
        bio
        website
        location
        role
        followersCount
        followingCount
        postsCount
        watchlistPublic
        interests
        languagePreferences
        verified
        totalAchievementPoints
        titles
        titleOrder
        titleUpdatedAt
        titleSource
        activeBadges
        badgeDisplaySettings
        reviewsCount
        likesReceived
        moviesWatched
        earlyDiscoveries
        loginStreak
        lastLoginDate
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const searchNews = /* GraphQL */ `
  mutation SearchNews($query: String!, $category: String, $limit: Int) {
    searchNews(query: $query, category: $category, limit: $limit) {
      id
      title
      description
      content
      source
      source_url
      author
      published_at
      featured_image
      tmdb_id
      media_type
      category
      tags
      status
      is_featured
      is_breaking
      created_by
      view_count
      bookmark_count
      share_count
      createdAt
      updatedAt
      bookmarks {
        nextToken
        __typename
      }
      views {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
